import { useEffect, useState } from "react";
import { getVideoList } from "../../../utils/API/mediaMethods";
import VideoList from "../../../components/VideoList/VideoList";
import { usePortal } from "../../../hooks/store";

export function Video() {
  const [videoList, setVideoList] = useState([]);
  const loadingPortal = usePortal();
  useEffect(() => {
    loadingPortal.setPortal();
    getVideoList().then(({ data }) => {
      setVideoList(data);
      loadingPortal.closePortal();
    });
  }, []);
  return <VideoList listData={videoList} />;
}
